import { render } from "./VentasDespachosView.vue?vue&type=template&id=0488760a&scoped=true"
import script from "./VentasDespachosView.vue?vue&type=script&lang=js"
export * from "./VentasDespachosView.vue?vue&type=script&lang=js"

import "./VentasDespachosView.vue?vue&type=style&index=0&id=0488760a&scoped=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0488760a"]])

export default __exports__